import { render } from "./EditItemModal.vue?vue&type=template&id=4ba26e0e&scoped=true"
import script from "./EditItemModal.vue?vue&type=script&lang=js"
export * from "./EditItemModal.vue?vue&type=script&lang=js"

import "./EditItemModal.vue?vue&type=style&index=0&id=4ba26e0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba26e0e"]])

export default __exports__